export const AWAITING_PAYMENT = 'awaiting_payment';
export const DEDUCTION_CREATED = 'deduction_created';
export const DELINQUENT = 'delinquent';
export const GOOD = 'good';
export const LATE = 'late';
export const STOP_PAYMENT = 'stop_payment';
export const STOP_PAYMENT_CANCELED_WITH_DEDUCTION =
    'stop_payment_canceled_with_deduction';
